import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { HexonAds } from './Ads';
import { HBox } from '../../../components/Box';
import { ControlPanel } from './controlPanel';
import { Button } from '../../../components/Buttons';

const Container = styled.div``;
const STATE = {
  view: 'iframe',
};
/* eslint-disable react/prefer-stateless-function */
class HexonOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        {/* <HBox left>
          <Button onClick={this.setStateFn({view:'list'})}>Lijst</Button>
        <Button onClick={this.setStateFn({view:'iframe'})}>Tabel</Button></HBox> */}
        {
            this.state.view == 'list' ? <HexonAds /> : <ControlPanel/> 
            }
      </Container>
    );
  }
}

HexonOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HexonOverview = compose(withConnect, withRouter)(HexonOverviewComp);
